import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout, setAuthUser } from '../../redux/slices/auth/authSlice';
import { setAppVersion } from '../../redux/slices/appSlice';
import { DEFAULT_LOCAL_PATH, VERSION } from '../../constents';
import { get } from '../Auths/AuthToken';
import { persistor } from '../../redux/store';

function VersionUpdatePopup() {
  const dispatch = useDispatch();
  const { appVersion: version } = useSelector((store) => store.app);

  useEffect(() => {
    const getAppversion = async () => {
      try {
        const response = await get('api/app/healthcheck', { silent: true });
        if (response.status === 200) {
          dispatch(setAppVersion(response.data.version));
        }
      } catch (error) {
        console.error('API call failed', error);
      }
    };

    // Initial call on mount
    getAppversion();

    // Poll every 15 minutes (15 * 60 * 1000 ms)
    const intervalId = setInterval(getAppversion, 1 * 60 * 1000);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [dispatch]);

  const onOk = () => {
    persistor.pause();
    persistor.purge().then(() => {
      dispatch(setAppVersion(''));
      localStorage.clear();
      dispatch(logout());
      dispatch(setAuthUser(null));
      window.location.href = `${DEFAULT_LOCAL_PATH}`;
    });
  };

  // agar state me version set hai aur vo VERSION ke baraber nahi hai
  if (version && String(version) !== String(VERSION)) {
    return (
      <div style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        backgroundColor: '#f97316',
        color: '#ffffff',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
        zIndex: 9999,
        maxWidth: '320px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        border: '1px solid #ea580c'
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>New Version Available</h2>
        </div>
        <div>
          <p style={{ fontSize: '14px', margin: 0, lineHeight: '1.5' }}>
            A newer version of the application is available. Please re-login to
            continue.
          </p>
        </div>
        <div>
          <button 
            onClick={onOk} 
            style={{ 
              padding: '8px 16px',
              backgroundColor: '#ffffff',
              color: '#ea580c',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '14px',
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
            }}
          >
            OK
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export default VersionUpdatePopup;
